'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.File = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n  height: 120px;\n  overflow: hidden;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ', ';\n  border-radius: 3px;\n  margin: 10px;\n  padding: 5px;\n  cursor: pointer;\n  text-align: center;\n  font-size: 12px;\n  color: ', ';\n  word-break: break-all;\n  user-select: none;\n'], ['\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n  height: 120px;\n  overflow: hidden;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ', ';\n  border-radius: 3px;\n  margin: 10px;\n  padding: 5px;\n  cursor: pointer;\n  text-align: center;\n  font-size: 12px;\n  color: ', ';\n  word-break: break-all;\n  user-select: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 40px !important;\n  color: ', ';\n  margin-bottom: 10px;\n  margin-top: 20px;\n'], ['\n  font-size: 40px !important;\n  color: ', ';\n  margin-bottom: 10px;\n  margin-top: 20px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 62px;\n'], ['\n  width: 100%;\n  height: 62px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n'], ['\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Input = require('../../Input/Input');

var _Input2 = _interopRequireDefault(_Input);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Colors
// Helpers


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var selected = _ref.selected;
  return selected ? _colors.blue : 'transparent';
}, _colors.darkGrey);

var FileIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject2, function (_ref2) {
  var loading = _ref2.loading;
  return loading ? _colors.red : _colors.darkGrey;
});

var ThumbnailContainer = _styledComponents2.default.div(_templateObject3);

var Thumbnail = _styledComponents2.default.img(_templateObject4);

var File = function (_Component) {
  _inherits(File, _Component);

  function File() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, File);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = File.__proto__ || Object.getPrototypeOf(File)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      newText: null
    }, _this.onTextChange = function (newText) {
      if (_this.props.loading) return;

      _this.setState({
        newText: newText
      });
    }, _this.onSelect = function (e) {
      var _this$props = _this.props,
          selectable = _this$props.selectable,
          onSelect = _this$props.onSelect,
          loading = _this$props.loading;
      if (!selectable || loading || _this.state.newText !== null) return;
      onSelect();
    }, _this.startEdit = function () {
      var _this$props2 = _this.props,
          editable = _this$props2.editable,
          loading = _this$props2.loading,
          text = _this$props2.text,
          onStartEdit = _this$props2.onStartEdit;
      if (!editable || loading) return;
      onStartEdit();

      _this.setState({
        newText: text
      });
    }, _this.doneEdit = function () {
      var newText = _this.state.newText;
      var _this$props3 = _this.props,
          editable = _this$props3.editable,
          onEdit = _this$props3.onEdit,
          loading = _this$props3.loading;
      if (!editable || loading || newText === null) return;
      if (newText && newText.trim().length > 0) onEdit(newText);

      _this.setState({
        newText: null
      });
    }, _this.cancelEdit = function () {
      var loading = _this.props.loading;
      if (loading) return;

      _this.setState({
        newText: null
      });
    }, _this.handleClickOutside = function () {
      _this.doneEdit();
    }, _this.focus = function (dom) {
      if (!dom) return;
      dom.focus();
    }, _this.isEnter = function (e) {
      switch (e.key) {
        case 'Enter':
          return _this.doneEdit();

        case 'Escape':
          return _this.cancelEdit();

        default:
          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(File, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.loading && !this.props.loading) this.setState({
        newText: null
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          text = _props.text,
          selected = _props.selected,
          loading = _props.loading,
          thumbnail = _props.thumbnail;
      var newText = this.state.newText;
      return _react2.default.createElement(Container, {
        selected: selected,
        onClick: this.onSelect,
        onDoubleClick: this.startEdit
      }, !loading && !!thumbnail && _react2.default.createElement(ThumbnailContainer, null, _react2.default.createElement(Thumbnail, {
        src: thumbnail
      })), (loading || !thumbnail) && _react2.default.createElement(FileIcon, {
        icon: loading ? 'loading2' : icon,
        spin: loading,
        loading: loading ? 1 : 0
      }), _react2.default.createElement('br', null), newText !== null ? _react2.default.createElement(_Input2.default, {
        value: newText,
        onChange: this.onTextChange,
        size: 'small',
        disabled: loading,
        innerRef: this.focus,
        onKeyDown: this.isEnter
      }) : text);
    }
  }]);

  return File;
}(_react.Component);

File.propTypes = {
  icon: _propTypes2.default.string,
  text: _propTypes2.default.string,
  thumbnail: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  selectable: _propTypes2.default.bool,
  onSelect: _propTypes2.default.func,
  editable: _propTypes2.default.bool,
  onEdit: _propTypes2.default.func,
  onStartEdit: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};
File.defaultProps = {
  icon: 'filetext1',
  text: '',
  thumbnail: null,
  selected: false,
  selectable: false,
  loading: false,
  editable: false,
  onSelect: function onSelect() {
    return null;
  },
  onEdit: function onEdit() {
    return null;
  },
  onStartEdit: function onStartEdit() {
    return null;
  }
};
exports.File = File;
exports.default = (0, _reactOnclickoutside2.default)(File);